import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import Http from "axios";
import config from "../config";
import { toast } from "react-toastify";
import Dropzone from "react-dropzone";

@inject("UserStore")
@observer
class Verf extends Component {
  state = {
    imageFront: {},
    imageBack: {}
  };

  onDropFront = file => {
    this.setState({
      imageFront: file[0]
    });
  };

  onDropBack = file => {
    this.setState({
      imageBack: file[0]
    });
  };

  updateBackCard = () => {
    Http.post(
      config.api + "/sign/id-card",
      {
        objectName: this.state.imageBack.name,
        contentType: this.state.imageBack.type
      },
      {
        withCredentials: true
      }
    ).then(url => {
      const options = {
        headers: {
          "Content-Type": this.state.imageBack.type
        },
        onUploadProgress: progress => {
          console.log(progress);
        }
      };

      console.log(this.state.imageBack);

      Http.put(url.data.result[0].signedUrl, this.state.imageBack, options)
        .then(res => {
          Http.post(
            config.api + "/identity/back",
            {
              url: url.data.result[0].fileKey
            },
            {
              withCredentials: true
            }
          ).then(image => {
            toast.info("Uploaded Back Photo ID");
            console.log(image);
          });
          console.log(res.data);
        })
        .catch(err => {
          toast.error("Failed to upload Back Photo ID");
          console.error(err);
        });
    });
  };

  updateFrontCards = () => {
    Http.post(
      config.api + "/sign/id-card",
      {
        objectName: this.state.imageFront.name,
        contentType: this.state.imageFront.type
      },
      {
        withCredentials: true
      }
    ).then(url => {
      const options = {
        headers: {
          "Content-Type": this.state.imageFront.type
        },
        onUploadProgress: progress => {
          console.log(progress);
        }
      };

      console.log(this.state.imageFront);

      Http.put(url.data.result[0].signedUrl, this.state.imageFront, options)
        .then(res => {
          Http.post(
            config.api + "/identity/front",
            {
              url: url.data.result[0].fileKey
            },
            {
              withCredentials: true
            }
          ).then(image => {
            toast.info("Uploaded Front Photo ID");
            console.log(image);
          });
          console.log(res.data);
        })
        .catch(err => {
          toast.error("Failed to upload Front Photo ID");
          console.error(err);
        });
    });
  };

  render() {
    const { user } = this.props.UserStore;
    return (
      <div className="verf-holder">
        <p class="title">
          Please upload your photo id and make sure it is visible and none of
          the information in it blurred or hidden so we can process your account
          correctly.
        </p>

        <div className="photos-holder">
          <div className="square">
            <p class="title">Front Side of Photo Id</p>
            <Dropzone
              onDrop={this.onDropFront}
              accept="image/*"
              multiple={false}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width:
                  this.state.imageFront.preview ||
                  (this.props.UserStore.user.identity &&
                    this.props.UserStore.user.identity.front)
                    ? "auto"
                    : "100%",
                height:
                  this.state.imageFront.preview ||
                  (this.props.UserStore.user.identity &&
                    this.props.UserStore.user.identity.front)
                    ? 300
                    : "100%",
                border: 0
              }}
            >
              {this.state.imageFront.preview ? (
                <img
                  className="image-prev"
                  src={this.state.imageFront.preview}
                  alt="Identity card preview"
                />
              ) : user.identity ? (
                user.identity.front ? (
                  <img
                    className="image-prev"
                    src={user.identity.front}
                    alt="Identity card front side"
                  />
                ) : (
                  <i className="fa fa-plus" />
                )
              ) : (
                <i className="fa fa-plus" />
              )}
            </Dropzone>
          </div>
          <div className="square">
            <p class="title">Back Side of Photo Id</p>
            <Dropzone
              onDrop={this.onDropBack}
              accept="image/*"
              multiple={false}
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                width:
                  this.state.imageBack.preview ||
                  (this.props.UserStore.user.identity &&
                    this.props.UserStore.user.identity.back)
                    ? "auto"
                    : "100%",
                height:
                  this.state.imageBack.preview ||
                  (this.props.UserStore.user.identity &&
                    this.props.UserStore.user.identity.back)
                    ? 300
                    : "100%",
                border: 0
              }}
            >
              {this.state.imageBack.preview ? (
                <img
                  className="image-prev"
                  src={this.state.imageBack.preview}
                  alt="Identity card back side"
                />
              ) : user.identity ? (
                user.identity.back ? (
                  <img
                    className="image-prev"
                    src={user.identity.back}
                    alt="Identity card back side"
                  />
                ) : (
                  <i className="fa fa-plus" />
                )
              ) : (
                <i className="fa fa-plus" />
              )}
            </Dropzone>
          </div>
        </div>
        <div className="btn-hold">
          <button
            onClick={() => {
              if (this.state.imageBack.preview) {
                toast.info("Uploading new Photo ID...");
                this.updateBackCard();
              }
              if (this.state.imageFront.preview) {
                toast.info("Uploading new Photo ID...");
                this.updateFrontCards();
              }
            }}
          >
            UPDATE PHOTO ID
          </button>
        </div>
      </div>
    );
  }
}

export default Verf;



// WEBPACK FOOTER //
// ./src/components/Verf.js